export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./logout.vue?vue&type=template&id=758e24b3"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/modals/logout/logout.vue?vue&type=template&id=758e24b3
// module id = MTM3
// module chunks = 0